import { gql } from '@apollo/client';

export const setPaymentAttempt = gql`mutation setCheckoutPaymentAttempt($offerId: String!) {
  setCheckoutPaymentAttempt(offerId: $offerId)
}`
